import { jwtDecode } from "jwt-decode";

export function getEmailFromToken() {
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const token = accessToken;

  if (!token) return null;

  const decodedToken = jwtDecode(token);

  // Dynamically find the email key
  const emailKey = Object.keys(decodedToken).find((key) =>
    key.toLowerCase().includes("email"),
  );

  return emailKey ? decodedToken[emailKey] : null;
}

export function getOrgIdFromToken() {
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const token = accessToken;

  if (!token) return null;

  const decodedToken = jwtDecode(token);

  // Dynamically find the email key
  const emailKey = Object.keys(decodedToken).find((key) =>
    key.toLowerCase().includes("serialnumber"),
  );

  return emailKey ? decodedToken[emailKey] : null;
}

export function getUserIdFromToken() {
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const token = accessToken;

  if (!token) return null;

  const decodedToken = jwtDecode(token);

  // Dynamically find the email key
  const emailKey = Object.keys(decodedToken).find((key) =>
    key.toLowerCase().includes("sid"),
  );

  return emailKey ? decodedToken[emailKey] : null;
}
